<template>
  <div />
</template>

<script>
export default {
  name: 'PromoView',
  mounted() {
    this.$router.push({ path: '/promo/products' });
  }
};
</script>
